import LojaModel from "./LojaModel";
import ProdutoModel from "./ProdutoModel";
import ConteudoModel from "./ConteudoModel";
import CategoriaModel from "./CategoriaModel";
import CarrinhoModel from "./CarrinhoModel";
import ProdutoTagModel from "./ProdutoTagModel";
import ProdutoDescricaoModel from "./ProdutoDescricaoModel";
import C5DataRetiradaModel from "./C5DataRetiradaModel";
import C5RetiradaItemModel from "./C5RetiradaItemModel";

class MockData {
  static getProdutoTags(): ProdutoTagModel[] {
    const tags: ProdutoTagModel[] = [];

    tags.push({
      produtoTagId: "1",
      nome: "Sem lactose",
      imagem: "/assets/images/icons/prod-ico-sem-lactose.svg"
    });
    tags.push({
      produtoTagId: "2",
      nome: "Novidade",
      imagem: "/assets/images/icons/prod-ico-novidade.svg"
    });
    tags.push({
      produtoTagId: "3",
      nome: "Sem glúten",
      imagem: "/assets/images/icons/prod-ico-sem-glutem.svg"
    });
    tags.push({
      produtoTagId: "4",
      nome: "Orgânico",
      imagem: "/assets/images/icons/prod-ico-organico.svg"
    });
    tags.push({
      produtoTagId: "5",
      nome: "Sem lactose",
      imagem: "/assets/images/icons/prod-ico-sem-lactose.svg"
    });
    tags.push({
      produtoTagId: "6",
      nome: "Kosher",
      imagem: "/assets/images/icons/prod-ico-kosher.svg"
    });
    tags.push({
      produtoTagId: "7",
      nome: "Importado",
      imagem: "/assets/images/icons/prod-ico-importado.svg"
    });
    tags.push({
      produtoTagId: "8",
      nome: "Diet",
      imagem: "/assets/images/icons/prod-ico-diet.svg"
    });
    tags.push({
      produtoTagId: "9",
      nome: "Pronto para consumo",
      imagem: "/assets/images/icons/prod-ico-pronto-para-consumo.svg"
    });

    return tags;
  }

  static getAgendamentoRetiradas(): C5DataRetiradaModel[] {
    const retiradas: C5DataRetiradaModel[] = [];

    const hoje: Date = new Date();
    const amanha: Date = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

    const horariosHoje: C5RetiradaItemModel[] = [];
    horariosHoje.push({
      lojaId: "1",
      dataEntrega: hoje,
      ScheduleID: "1230",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "9:00 - 10:00"
    } as C5RetiradaItemModel);
    horariosHoje.push({
      lojaId: "1",
      dataEntrega: hoje,
      ScheduleID: "1231",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "10:00 - 11:00"
    } as C5RetiradaItemModel);
    horariosHoje.push({
      lojaId: "1",
      dataEntrega: hoje,
      ScheduleID: "1232",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "11:00 - 12:00"
    } as C5RetiradaItemModel);
    horariosHoje.push({
      lojaId: "1",
      dataEntrega: hoje,
      ScheduleID: "1233",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "13:00 - 14:00"
    } as C5RetiradaItemModel);
    horariosHoje.push({
      lojaId: "1",
      dataEntrega: hoje,
      ScheduleID: "1234",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "14:00 - 15:00"
    } as C5RetiradaItemModel);

    const agendamentoHoje: C5DataRetiradaModel = {
      lojaId: "1",
      dataEntrega: hoje,
      itens: horariosHoje
    } as C5DataRetiradaModel;

    const horariosAmanha: C5RetiradaItemModel[] = [];
    horariosAmanha.push({
      lojaId: "1",
      dataEntrega: amanha,
      ScheduleID: "1240",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "09:00 - 10:00"
    } as C5RetiradaItemModel);
    horariosAmanha.push({
      lojaId: "1",
      dataEntrega: amanha,
      ScheduleID: "1241",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "10:00 - 11:00"
    } as C5RetiradaItemModel);
    horariosAmanha.push({
      lojaId: "1",
      dataEntrega: amanha,
      ScheduleID: "1242",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "11:00 - 12:00"
    } as C5RetiradaItemModel);
    horariosAmanha.push({
      lojaId: "1",
      dataEntrega: amanha,
      ScheduleID: "1243",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "13:00 - 14:00"
    } as C5RetiradaItemModel);
    horariosAmanha.push({
      lojaId: "1",
      dataEntrega: amanha,
      ScheduleID: "1244",
      DeliveryCapacity: 5,
      DeliveryDate: hoje,
      DeliveryHour: "14:00 - 15:00"
    } as C5RetiradaItemModel);

    const agendamentoAmanha: C5DataRetiradaModel = {
      lojaId: "1",
      dataEntrega: amanha,
      itens: horariosAmanha
    } as C5DataRetiradaModel;

    retiradas.push(agendamentoHoje);
    retiradas.push(agendamentoAmanha);

    return retiradas;
  }

  static getCarrinho(): CarrinhoModel {
    const carrinho: CarrinhoModel = {
      carrinhoId: this.uuidv4(),
      carrinhoItens: [
        {
          adicionado: new Date(),
          carrinhoItemId: this.uuidv4(),
          notas: "Escolher produtos muito bem!",
          quantidade: 3,
          produto: this.getProduto("1")
        }
      ]
    } as CarrinhoModel;

    return carrinho;
  }

  static getCategorias(): CategoriaModel[] {
    const categorias: CategoriaModel[] = [];

    categorias.push({
      categoriaId: "1",
      imagem: "assets/images/categorias/acougue-e-peixaria.png",
      nome: "Açougue e Peixaria"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "2",
      imagem: "assets/images/categorias/adega-e-bebidas.png",
      nome: "Adega e bebidas"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "3",
      imagem: "assets/images/categorias/floricultura.png",
      nome: "Floricultura"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "4",
      imagem: "assets/images/categorias/frios-e-laticinios.png",
      nome: "Frios e Laticínios"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "5",
      imagem: "assets/images/categorias/hortifruti-e-folhagens.png",
      nome: "Hortifruti e Folhagens"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "6",
      imagem: "assets/images/categorias/mecearia-e-cereais.png",
      nome: "Mercearia e Cereais"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "7",
      imagem: "assets/images/categorias/padaria-e-doces.png",
      nome: "Padaria e Doces"
    } as CategoriaModel);

    categorias.push({
      categoriaId: "8",
      imagem: "assets/images/categorias/rotisseria.png",
      nome: "Rotisseria"
    } as CategoriaModel);

    return categorias;
  }

  static getSubcategorias(): CategoriaModel[] {
    const subcats: CategoriaModel[] = [];

    subcats.push({
      categoriaId: "12",
      nome: "Ofertas",
      categoriaPaiId: "4",
      nivel: 1
    });
    subcats.push({
      categoriaId: "13",
      nome: "Queijos",
      categoriaPaiId: "4",
      nivel: 1
    });
    subcats.push({
      categoriaId: "14",
      nome: "Embutidos",
      categoriaPaiId: "4",
      nivel: 1
    });
    subcats.push({
      categoriaId: "15",
      nome: "Laticínios",
      categoriaPaiId: "4",
      nivel: 1
    });

    return subcats;
  }

  static getProdutos(): ProdutoModel[] {
    const prods: ProdutoModel[] = [];

    const descricoes: ProdutoDescricaoModel[] = [
      {
        descricaoId: "1",
        titulo: "Benefícios do produto",
        descricao: `Com sabor levemente docinho e coloração bem avermelhada, ele agrada o paladar das crianças
        e ainda garante nutrientes importantes para formação dos dentes e ossos, além de ajudar no
        fortalecimento do sistema imunológico. Pode ser usado desde petiscos até pratos mais
        elaborados, dando um toque encantador e saboroso. Experimente!`
      } as ProdutoDescricaoModel,
      {
        descricaoId: "2",
        titulo: "Produtor",
        descricao: `Vai preparar o lanche das crianças? Inclua os mini tomates Oba Bem Querer! Além de
      saborosos, os tomatinhos são incríveis !`
      } as ProdutoDescricaoModel,
      {
        descricaoId: "3",
        titulo: "Informação nutricional",
        descricao: `Quantidade por porção de 20g (10 unidades)
        <table cellPadding="0" cellSpacing="0">
          <tr>
            <th className="col-1">
            </th>
            <th className="col-2">
              Qtd por porção
            </th>
            <th className="col-2">
              % VD (*)
            </th>
          </tr>
          <tr>
            <td>Valor energético</td>
            <td>1000 kcal = 1000 kj</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>Carboidratos</td>
            <td>9999 g</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>Proteinas</td>
            <td>9999 g</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>Gorduras totais</td>
            <td>9999 g</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>Gorduras saturadas</td>
            <td>9999 g</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>Gorduras trans</td>
            <td>9999 g</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>Fibra alimentar</td>
            <td>9999 g</td>
            <td>100%</td>
          </tr>
        </table>

        (*) % Valores Diários com base em uma dieta de 2.000 kcal ou 8400 Kj.
        Seus valores diários podem ser maiores ou menores dependendo das
        suas necessidades nergéticas.
        `
      } as ProdutoDescricaoModel
    ];

    prods.push({
      produtoId: "2521",
      categoria: "Oba Bem Querer1",
      imagem: "https://oba-img.azureedge.net/product/15571-pessego-grego-em-calda-oba-bem-querer-680-g-m.jpg",
      unidade: "un.",
      nome: "Conserva Grega - Pêssegos em Calda 680g - COMPRE 5 PAGUE 4",
      precoOriginal: 21.5,
      precoDesconto: 21.15,
      fatorMultiplicacao: 0,
      marca: "Pessegueiro",
      descricoes: descricoes
    } as ProdutoModel);

    prods.push({
      produtoId: "1898",
      categoria: "Oba Bem Querer2",
      imagem: "https://oba-img.azureedge.net/product/17912-suco-de-uva-tinto-integral-oba-bem-querer-1-l-m.jpg",
      unidade: "un.",
      nome: "Suco de Uva Integral 1L - COMPRE 5 PAGUE 4 ",
      precoOriginal: 22.5,
      precoDesconto: 22.15,
      fatorMultiplicacao: 0,
      marca: "Del valle",
      descricoes: descricoes
    } as ProdutoModel);

    prods.push({
      produtoId: "4171",
      categoria: "Oba Bem Querer3",
      imagem: "https://oba-img.azureedge.net/product/18229-mostarda-hemmer-tipo-dijon-200-g-m.jpg",
      unidade: "un.",
      nome: "Mostarda Francesa Dijon Tradicional 215g",
      precoOriginal: 10.99,
      precoDesconto: 10.99,
      fatorMultiplicacao: 0,
      marca: "Heinz",
      descricoes: descricoes
    } as ProdutoModel);

    return prods;
  }

  static getProduto(id: string): ProdutoModel {
    const items: any = this.getProdutos().filter(l => l.produtoId === id);

    if (items.length === 1) {
      return items[0];
    } else {
      throw new Error("Produto não encontrado");
    }
  }

  static getConteudos(): ConteudoModel[] {
    const conteudos: ConteudoModel[] = [];

    conteudos.push({
      conteudoId: "1",
      curtido: true,
      imagem: "/assets/images/thumbnail-1.png",
      nome: "Tudo para um churrasco gaúcho",
      tipo: "Lista",
      resumo: "Tudo para um churrasco gaúcho"
    } as ConteudoModel);
    conteudos.push({
      conteudoId: "2",
      curtido: true,
      imagem: "/assets/images/thumbnail-2.png",
      nome: "Tudo para um churrasco gaúcho",
      tipo: "Lista",
      resumo: "Tudo para um churrasco gaúcho"
    } as ConteudoModel);
    conteudos.push({
      conteudoId: "3",
      curtido: true,
      imagem: "/assets/images/thumbnail-3.png",
      nome: "Tudo para um churrasco gaúcho",
      tipo: "Lista",
      resumo: "Tudo para um churrasco gaúcho"
    } as ConteudoModel);

    return conteudos;
  }

  static getConteudo(id: string): ConteudoModel {
    const items: any = this.getConteudos().filter(l => l.conteudoId === id);

    if (items.length === 1) {
      return items[0];
    } else {
      throw new Error("Conteúdo não encontrada");
    }
  }

  static getCategoria(id: string): CategoriaModel {
    const items: any = this.getCategorias().filter(l => l.categoriaId === id);

    if (items.length === 1) {
      return items[0];
    } else {
      const itemsSub: any = this.getSubcategorias().filter(
        l => l.categoriaId === id
      );

      if (itemsSub.length === 1) {
        return itemsSub[0];
      } else {
        throw new Error("Categoria não encontrada");
      }
    }
  }

  static getLojas(): LojaModel[] {
    const lojas: LojaModel[] = [];

    const loja1: LojaModel = {
      lojaId: "11",
      nome: "Oba Morumbi",
      bairro: "Indianópolis",
      cidade: "São Paulo",
      uf: "SP",
      cep: "04523-001",
      funcionamento: "Seg.-Dom.: 7:00 - 22:00",
      logradouro: "Av. Macuco",
      numero: "655 A",
      telefones: "011 3333-4444",
      latitude: -23.604934,
      longitude: -46.6668757
    } as LojaModel;

    const loja2: LojaModel = {
      lojaId: "2",
      nome: "Carolina florence",
      bairro: "Vila Mariana",
      cidade: "São Paulo",
      uf: "SP",
      cep: "04523-001",
      funcionamento: "Todos os dias 7h às 22h",
      logradouro: "Rua Domingos de Morais",
      numero: "2931",
      telefones: "11 4280-2406",
      latitude: -23.6022897,
      longitude: -46.6386355
    } as LojaModel;

    lojas.push(loja1);
    lojas.push(loja2);

    return lojas;
  }

  static getLoja(id: string | null): LojaModel {
    const loja: any = this.getLojas().filter(l => l.lojaId === id);

    if (loja.length === 1) {
      return loja[0];
    } else {
      throw new Error("Loja não encontrada");
    }
  }

  static uuidv4(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      // tslint:disable-next-line:no-bitwise
      const r: any = (Math.random() * 16) | 0,
        // tslint:disable-next-line:no-bitwise
        v: any = c === "x" ? r : r & (0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export default MockData;
